// The mobile pricing bar has nothing to add while the pricing section is on
// screen, so it slides away there and comes back once the section scrolls off.
type ObserverFactory = (callback: IntersectionObserverCallback) => Pick<IntersectionObserver, 'observe'>

export function bindPricingBar(
  bar: HTMLElement,
  root: ParentNode = document,
  observe: ObserverFactory = (callback) => new IntersectionObserver(callback),
): void {
  const pricing = root.querySelector<HTMLElement>('#pricing')
  if (!pricing) return
  observe((entries) => {
    entries.forEach((entry) => bar.classList.toggle('is-hidden', entry.isIntersecting))
  }).observe(pricing)
}
